import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import { PendingUserOverview, UserOverview, UserAccessType, AuthorizedUserAccessType, JobRole, User, EditUser,ResetPasswordAdminViewModel } from '../models/user.model';
import { Tuple, SerializedTuple } from '../models/tuple.model';
import { AccessOption } from '../models/access.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LanguageViewModel } from '../../preferences/models/preferences.model';
import { ApiResponse } from '../../manage-equipment/models/manage-equipment.model';

@Injectable()
export class UserServiceIdentity {
    private readonly GetAllUsersApiAddress = 'api/admin/GetAllUsersForUser';
    private readonly GetAllPendingUsersApiAddress = 'api/admin/GetAllPendingUsersForUser';
    private readonly GetUserAccessTypeApiAddress = 'api/admin/GetAccessLevelForUser';
    private readonly GetUserJobRolesApiAddress = 'api/admin/GetUserJobRoles';
    private readonly GetAuthorizedUserAccessTypesApiAddress = 'api/admin/GetAuthorizedAccessTypesForUser';
    private readonly GetAssignableJobRolesApiAddress = 'api/admin/GetAssignableJobRolesForUser';
    private readonly InviteNewUserApiAddress = 'api/admin/InviteNewUser';
    private readonly CancelInvitationApiAddress = 'api/admin/CancelInvitation';
    private readonly DisableUserApiAddress = 'api/admin/DisableUser';
    private readonly EnableUserApiAddress = 'api/admin/EnableUser';
    private readonly GetUserDetailsApiAddress = 'api/admin/GetUserDetails';
    private readonly UpdateUserApiAddress = 'api/admin/UpdateUser';
    private readonly CreateUserApiAddress = 'account/CreateUser';
    private readonly GetUserBrandStyle = 'api/admin/GetBrandStyle';
  private readonly ResetPassword = 'Account/ResetPasswordAdmin';
  private readonly hasMenuAccessApiAddress = 'api/admin/HasMenuAccess';

    constructor(private _http: HttpClient) { }

    public getAllUsers(userRequestModel: any): Observable<UserOverview[]> {
        // return this._http.get(this.GetAllUsersApiAddress).share().map(
        //     (response: Response) => <UserOverview[]>response.json()).catch(this.handleError);
        return this._http.post<UserOverview[]>(this.GetAllUsersApiAddress,userRequestModel).pipe(catchError(this.handleError));
    }

    public getUserDetails(userId: number): Observable<EditUser> {
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('userId', userId.toString());
        // return this._http.get(this.GetUserDetailsApiAddress, { search: params }).share().map(
        //     (response: Response) => <EditUser>response.json()).catch(this.handleError);
      const params = {
        params: new HttpParams().set('userId', userId.toString())
      };
      return this._http.get<EditUser>(this.GetUserDetailsApiAddress, params).pipe(catchError(this.handleError));
    }

    public enableUser(userId: number): Observable<Tuple> {
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('userId', userId.toString());
        // return this._http.get(this.EnableUserApiAddress, { search: params }).share().map(
        //     (response: Response) => <Tuple>response.json()).catch(this.handleError);

        const params = {
          params: new HttpParams().set('userId', userId.toString())
        };
        return this._http.get<Tuple>(this.EnableUserApiAddress, params).pipe(catchError(this.handleError));
    }

    public disableUser(userId: number): Observable<Tuple> {
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('userId', userId.toString());
        // return this._http.get(this.DisableUserApiAddress, { search: params }).share().map(
        //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('userId', userId.toString())
        };
        return this._http.get<Tuple>(this.DisableUserApiAddress, params).pipe(catchError(this.handleError));
    }

    public cancelInvitation(invitationId: number): Observable<Tuple> {
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('invitationId', invitationId.toString());
        // return this._http.get(this.CancelInvitationApiAddress, { search: params }).share().map(
        //     (response: Response) => <Tuple>response.json()).catch(this.handleError);

        const params = {
          params: new HttpParams().set('invitationId', invitationId.toString())
        };
        return this._http.get<Tuple>(this.CancelInvitationApiAddress, params).pipe(catchError(this.handleError));
    }

    public getPendingUsers(userRequestModel: any): Observable<PendingUserOverview[]> {
            return this._http.post<PendingUserOverview[]>(this.GetAllPendingUsersApiAddress,userRequestModel).pipe(catchError(this.handleError));
    }

    public updateUser(user: User): Observable<Tuple> {
        // return this._http.post(this.UpdateUserApiAddress, user).share().map(
        //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
            return this._http.post<Tuple>(this.UpdateUserApiAddress, user).pipe(catchError(this.handleError));
    }

    public inviteNewUser(newUser: User): Observable<Tuple> {
        // return this._http.post(this.InviteNewUserApiAddress, newUser).share().map(
        //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
            return this._http.post<Tuple>(this.InviteNewUserApiAddress, newUser).pipe(catchError(this.handleError));
    }

    public createNewUser(newUser: User): Observable<SerializedTuple> {
        // return this._http.post(this.CreateUserApiAddress, newUser).share().map(
        //     (response: Response) => <SerializedTuple>response.json()).catch(this.handleError);
        return this._http.post<SerializedTuple>(this.CreateUserApiAddress, newUser).pipe(catchError(this.handleError));
    }

    // return this._http.get(this.GetAssignableJobRolesApiAddress).share().map(
            public getAssignableJobRoles(): Observable<JobRole[]> {
        //     (response: Response) => <JobRole[]>response.json()).catch(this.handleError);
        return this._http.get<JobRole[]>(this.GetAssignableJobRolesApiAddress).pipe(catchError(this.handleError));
    }

    public getUserAccessType(): Observable<UserAccessType> {
        // return this._http.get(this.GetUserAccessTypeApiAddress).share().map(
        //     (response: Response) => <UserAccessType>response.json()).catch(this.handleError);
        return this._http.get<UserAccessType>(this.GetUserAccessTypeApiAddress).pipe(catchError(this.handleError));
    }

    public getUserJobRoles(): Observable<string[]> {
        // return this._http.get(this.GetUserJobRolesApiAddress).share().map(
        //     (response: Response) => <string[]>response.json()).catch(this.handleError);
        return this._http.get<string[]>(this.GetUserJobRolesApiAddress).pipe(catchError(this.handleError));
    }

    public getAuthorizedUserAccessTypes(): Observable<AuthorizedUserAccessType[]> {
        // return this._http.get(this.GetAuthorizedUserAccessTypesApiAddress).share().map(
        //     (response: Response) => <AuthorizedUserAccessType[]>response.json()).catch(this.handleError);
        return this._http.get<AuthorizedUserAccessType[]>(this.GetAuthorizedUserAccessTypesApiAddress).pipe(catchError(this.handleError));
    }

    public GetBrandStyle(Id:number, AccessId:number): Observable<string> {
        const params = {
            params: new HttpParams().set('Id', Id.toString()).set('AccessId', AccessId.toString())
          };
        return this._http.get<string>(this.GetUserBrandStyle,params).pipe(catchError(this.handleError));
    }


    public getAllLanguages(): Observable<LanguageViewModel[]> {
       
        return this._http.get<LanguageViewModel[]>("api/preferences/GetAllLanguages").pipe(catchError(this.handleError));
    }
    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    public resetPassword(model: ResetPasswordAdminViewModel): Observable<ApiResponse> {
        return this._http.post<ApiResponse>(this.ResetPassword, model).pipe(catchError(this.handleError));
  }

  public hasMenuAccess(menuName: string): Observable<boolean> {
    const params = {
      params: new HttpParams().set('MenuName', menuName)
    };
    return this._http.get<boolean>(this.hasMenuAccessApiAddress, params).pipe(catchError(this.handleError));
  }


}
